export default "__VITE_ASSET__197c8be2__"